import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    currentLocale: 'es',
    messages: {},
};

const locale = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.SET_LOCALE) {
        return { ...state, currentLocale: action.payload.locale };
    }
    return state;
};

export default locale;



/** WEBPACK FOOTER **
 ** ./src/reducers/locale.js
 **/